export const initAdvancedHeroSlider = (): void => {
  // Find all instances of this specific slider
  const sliders = document.querySelectorAll<HTMLElement>(".mtc-hero-swiper");

  if (sliders.length === 0) return;

  // Güvenli Obje Çıkarma (ESM / Default uyumsuzluğunu çözer)
  const rawSwiper = window.EcommerceCore.vendors.Swiper;
  const SwiperClass = (rawSwiper as any).default || rawSwiper;

  const { Autoplay, Pagination, EffectFade } =
    window.EcommerceCore.vendors.SwiperModules;

  sliders.forEach((sliderElement) => {
    // Avoid double initialization
    if (sliderElement.dataset.initialized === "true") return;
    sliderElement.dataset.initialized = "true";

    const slideCount = sliderElement.querySelectorAll(".swiper-slide").length;

    // `new Swiper` yerine güvenli olan `new SwiperClass` kullanıyoruz
    new SwiperClass(sliderElement, {
      modules: [Autoplay, Pagination, EffectFade],
      loop: slideCount > 1, // Only loop if there are multiple slides
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay:
        slideCount > 1
          ? {
              delay: 5000,
              disableOnInteraction: false,
            }
          : false, // Disable autoplay if only 1 slide
      pagination: {
        el: sliderElement.querySelector(".mtc-hero-pagination") as HTMLElement,
        clickable: true,
      },
      // Ensures images are loaded properly before sliding
      observer: true,
      observeParents: true,
    });
  });

  console.log("[AdvancedHeroSlider] Swiper Initialized.");
};
